import { render } from "./ImageMarkupConfigControl.vue?vue&type=template&id=ced2c7ae"
import script from "./ImageMarkupConfigControl.vue?vue&type=script&lang=js"
export * from "./ImageMarkupConfigControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__